import { ComponentsCustomerType } from "@omni/types/components/customer/shared/customerType.enum";
import { cn } from "@omni/utils/styles";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { getVatPrefixes } from "@/redux/modules/api/data/vatPrefixes/vatPrefixes.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { RadioFieldArray } from "../../../FormFields/RadioFieldArray/radioFieldArray.component";
import { TextField } from "../../../FormFields/TextField/Textfield.component";
import { VatField } from "../../../FormFields/VatField/vatField.container";
import { CustomerFormBlockFormValues } from "../customerFormBlock.schema";

const CustomerTypeFormBlock = () => {
    const { t } = useGranite();
    const vatPrefixes = useSelector(getVatPrefixes, shallowEqual);

    const { getValues, subscribe, setValue } =
        useFormContext<CustomerFormBlockFormValues>();
    const [isB2B, setIsB2B] = useState(
        getValues("customerType") === ComponentsCustomerType.B2B
    );

    useEffect(() => {
        const callback = subscribe({
            formState: { values: true },
            callback: ({ values }) => {
                const { customerType, vatInfo } = values;
                const shouldBeB2B = customerType === ComponentsCustomerType.B2B;
                if (shouldBeB2B !== isB2B) {
                    setIsB2B(shouldBeB2B);
                }

                if (shouldBeB2B && !vatInfo?.vatNrPrefix) {
                    setValue("vatInfo.vatNrPrefix", "BE");
                }
            }
        });

        return () => callback();
    }, [subscribe, isB2B, setValue]);

    return (
        <>
            <div className={cn("tw:mb-4")}>
                <RadioFieldArray<
                    CustomerFormBlockFormValues,
                    ComponentsCustomerType
                >
                    name="customerType"
                    hideMicroCopy
                    className={cn("tw:flex tw:gap-4")}
                    required
                    label={t("general.form.customer.type")}
                    options={[
                        {
                            label: t("general.form.customerType.label.b2c"),
                            value: ComponentsCustomerType.B2C
                        },
                        {
                            label: t("general.form.customerType.label.b2b"),
                            value: ComponentsCustomerType.B2B
                        }
                    ]}
                />
            </div>
            {isB2B && (
                <Row>
                    <Col
                        md={6}
                        xs={12}
                    >
                        <VatField<CustomerFormBlockFormValues>
                            label={t("general.form.vatNr.label")}
                            required={true}
                            vatPrefixes={vatPrefixes}
                        />
                    </Col>
                    <Col
                        md={6}
                        xs={12}
                    >
                        <TextField<CustomerFormBlockFormValues>
                            name="vatInfo.companyName"
                            label={t("general.form.companyName.label")}
                            required
                            autoComplete={"organization"}
                            placeholder={t(
                                "general.form.companyName.placeholder"
                            )}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};

export { CustomerTypeFormBlock };
